export default __webpack_public_path__ + "static/media/chain-3.ca7acea7.png";